import Vue from 'vue'
import Router from 'vue-router'

import Home from '../pages/index.vue'
import khfw from '../pages/khfw.vue'
import pzhc from '../pages/pzhc.vue'
import yqyy from '../pages/yqyy.vue'
import nyzx from '../pages/nyzx.vue'

Vue.use(Router)

export default new Router({
  mode: 'history', // 可选：'hash'
  routes: [
    {
      path: '/',
      name: '园区数据分析',
      component: Home
    },
    {
      path: '/khfw',
      name: '客户工单分析',
      component: khfw
    },
    {
      path: '/pzhc',
      name: '品质核查分析',
      component: pzhc
    },
    {
      path: '/yqyy',
      name: '园区运营分析',
      component: yqyy
    },
    {
      path: '/nyzx',
      name: '能源中心管理',
      component: nyzx
    },
  ]
})
